import React from 'react';
export const inputClass = 'w-full rounded-lg border border-line bg-white px-3 py-2 text-sm text-ink placeholder:text-ink-muted/70 transition-colors duration-150 ease-out focus:border-green-400 focus:outline-none focus:ring-2 focus:ring-green-100';
interface FieldProps {
  label: string;
  hint?: string;
  htmlFor?: string;
  children: React.ReactNode;
  className?: string;
}
export function Field({
  label,
  hint,
  htmlFor,
  children,
  className = ''
}: FieldProps) {
  return <div className={className} data-id="element-432" data-mp="d31rnt50mnzl">
      <label htmlFor={htmlFor} className="mb-1.5 block text-[13px] font-medium text-ink" data-id="element-433" data-mp="d2044p6tc90z">
        {label}
      </label>
      {children}
      {hint && <p className="mt-1 text-xs text-ink-muted" data-id="element-434" data-mp="hvuv8doqzqa3">{hint}</p>}
    </div>;
}
interface ToggleProps {
  checked: boolean;
  onChange: (v: boolean) => void;
  label: string;
  opis?: string;
}
export function Toggle({
  checked,
  onChange,
  label,
  opis
}: ToggleProps) {
  return <div className="flex items-start justify-between gap-4 rounded-lg border border-line bg-white px-3 py-2.5" data-id="element-435" data-mp="wrkazu3cb76d">
      <div data-id="element-436" data-mp="ycr2fmda6jay">
        <p className="text-sm font-medium text-ink" data-id="element-437" data-mp="y9d0gf8j4c41">{label}</p>
        {opis && <p className="mt-0.5 text-xs text-ink-muted" data-id="element-438" data-mp="tarwc4q5p8ab">{opis}</p>}
      </div>
      <button type="button" role="switch" aria-checked={checked} aria-label={label} onClick={() => onChange(!checked)} className={`mt-0.5 h-6 w-11 shrink-0 rounded-full border transition-colors duration-150 ease-out ${checked ? 'border-green-500 bg-green-500' : 'border-line bg-slate-200'}`} data-id="element-439" data-mp="oci2pyk2yfqt">
        <span className={`block h-5 w-5 rounded-full bg-white transition-transform duration-150 ease-out ${checked ? 'translate-x-[22px]' : 'translate-x-0.5'}`} data-id="element-440" data-mp="17c4b4ctkz3um" />
      </button>
    </div>;
}